var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.069,
    y1: 1,
    x2: 1.08,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff543e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c837ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M1.952,2.114C-.477,4.636.02,7.316.02,15.457c0,6.76-1.18,13.538,4.995,15.133,1.928.5,19.012.5,20.937,0,2.571-.663,4.662-2.748,4.948-6.383.04-.507.04-16.978,0-17.5C30.595,2.836,28.211.6,25.07.153A27.813,27.813,0,0,0,20.512.011C7.409.017,4.537-.566,1.952,2.114Z",
    transform: "translate(0.07 0.038)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M15.4,3.142c-5.026,0-9.8-.447-11.621,4.229-.753,1.931-.644,4.44-.644,8.031,0,3.152-.1,6.114.644,8.03,1.819,4.679,6.63,4.231,11.618,4.231,4.812,0,9.774.5,11.619-4.231.754-1.951.644-4.422.644-8.03,0-4.79.264-7.882-2.06-10.2C23.251,2.848,20.069,3.142,15.4,3.142ZM14.3,5.352c10.483-.017,11.817-1.182,11.081,15-.262,5.724-4.621,5.1-9.981,5.1-9.772,0-10.053-.279-10.053-10.051,0-9.885.775-10.04,8.952-10.048ZM21.95,7.387a1.471,1.471,0,1,0,1.471,1.471A1.471,1.471,0,0,0,21.95,7.387ZM15.4,9.107a6.3,6.3,0,1,0,6.3,6.3,6.3,6.3,0,0,0-6.3-6.3Zm0,2.209c5.4,0,5.412,8.174,0,8.174S9.991,11.316,15.4,11.316Z",
    transform: "translate(0.131 0.099)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.edf95cf6c006c4c7369fb2f474ee2f9a.svg";
export { ForwardRef as ReactComponent };